import React from "react";
import { Avatar } from "@bookingcom/bui-react";
import { PickerDesktop } from "../Picker";
import "./LanguagePicker.types";
import styles from "./LanguagePicker.module.css";
var LanguagePicker = function (props) {
    var children = props.children, languageSelection = props.languageSelection, selectedLanguageId = props.selectedLanguageId, selectedFlagUrl = props.selectedFlagUrl, attributes = props.attributes, triggerAttributes = props.triggerAttributes, onOpen = props.onOpen, onClose = props.onClose;
    var renderSign = function (item, selected) {
        return (React.createElement(Avatar, { className: !selected ? styles.flag : "", src: item.flagUrl, backgroundSize: item.backgroundSize, backgroundPosition: item.backgroundPosition, size: "small" }));
    };
    var renderSelectedSign = function (item) {
        return selectedFlagUrl ? (React.createElement(Avatar, { src: selectedFlagUrl, size: "small" })) : (renderSign(item, true));
    };
    return (React.createElement(PickerDesktop, { selection: languageSelection, selectedId: selectedLanguageId, attributes: attributes, triggerAttributes: triggerAttributes, renderSign: renderSign, renderSelectedSign: renderSelectedSign, onOpen: onOpen, onClose: onClose }, children));
};
export default LanguagePicker;
